// extracted by mini-css-extract-plugin
export default {"container":"gEbEIF","spacing":"mQpM_g"};